import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BrandLogo from '../BrandLogo';
import { APP_DISPLAY_NAME } from '../../appMeta';

export interface LandingNavProps {
  onLoginClick: () => void;
}

const LandingNav: React.FC<LandingNavProps> = ({ onLoginClick }) => {
  const location = useLocation();
  const path = location.pathname;
  const isHome = path === '/' || path === '';
  const isIntro = path === '/intro' || path.startsWith('/intro/');
  const isNotices = path === '/notices' || path.startsWith('/notices/');
  const isQa = path === '/qa' || path.startsWith('/qa/');
  const isPass = path === '/pass' || path.startsWith('/pass/');

  return (
    <nav className="landing-nav">
      <div className="landing-nav-content">
        <Link to="/" className="landing-nav-logo" aria-label={APP_DISPLAY_NAME}>
          <BrandLogo className="cp-brand-logo--nav" />
        </Link>
        <div className="landing-nav-menus" role="navigation" aria-label="랜딩 메뉴">
          <Link to="/" className={`landing-nav-menu-link${isHome ? ' is-active' : ''}`}>
            Home
          </Link>
          <Link to="/intro" className={`landing-nav-menu-link${isIntro ? ' is-active' : ''}`}>
            서비스 소개
          </Link>
          <Link to="/notices" className={`landing-nav-menu-link${isNotices ? ' is-active' : ''}`}>
            공지사항
          </Link>
          <Link to="/qa" className={`landing-nav-menu-link${isQa ? ' is-active' : ''}`}>
            Q&amp;A
          </Link>
          <Link to="/pass" className={`landing-nav-menu-link${isPass ? ' is-active' : ''}`}>
            이용권 안내
          </Link>
        </div>
        <button type="button" className="landing-nav-login-btn" onClick={onLoginClick}>
          로그인
        </button>
      </div>
    </nav>
  );
};

export default LandingNav;
